export default __webpack_public_path__ + "static/media/tv.d1669fef.png";